import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _MarketPlaceCategory, _MarketPlacePrice } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { EditorPriceList } from "../../../Factoty&Production/PriceList/EditorPriceList";
import { InputDate } from "../../../theme/Input/InputDate";
import { PriceListItem } from "../../../Factoty&Production/PriceList/PriceListItem";

interface Props {
    idMarketPlace: number;
}

export const MarketPlacePrice = ({ idMarketPlace }: Props) => {

    const markcatpric = useDataBean(_MarketPlacePrice);

    const single = Singleton.getInstance();
    const [modallista, setModallista] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idMarketPlace])

    const getLista = () => {

        markcatpric.instance.getMarketPlacePriceListCatalog(idMarketPlace).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        markcatpric.setBean({
            IDMarketPlace: idMarketPlace
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {

        markcatpric.instance.deleteMarketPlacePriceList(markcatpric.bean.IDMarketPlacePriceList).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )
    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        markcatpric.instance.addPriceListToMarketPlace(markcatpric.bean.IDPriceList, markcatpric.bean.FromDate, idMarketPlace).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDMarketPlacePriceList', visible: true },
        { title: 'Listado de precios', property: 'PriceListName', visible: true },
        { title: 'Fecha desde', property: 'FromDate', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Ver Lista de Precios', icono: 'ri-list-check', visible: single.canEdit(), evento: () => { setModallista({ ...modallista, "name": `Lista de Precios de ${markcatpric.bean.PriceListName}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={markcatpric.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate name="FromDate" label="Fecha desde" value={markcatpric.bean.FromDate} setDate={(e: any) => { markcatpric.setBean({ ...markcatpric.bean, "FromDate": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <EditorPriceList onChange={(e) => { markcatpric.setBean({ ...markcatpric.bean, IDPriceList: e.IDPriceList }) }} label="Listado de precios" />
                        </div>

                    </div>
                </Modal>
                <Modal modal={modallista} updateModal={setModallista}>
                    <div className="row">
                        <PriceListItem IDPriceList={markcatpric.bean.IDPriceList} />

                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}